module.exports = __webpack_public_path__ + "static/media/bg-login.e1c938b6.jpg";